import { UIComponentProps, UIComponentHandler, UIComponentImpl, UIComponentState, UIDataModel } from 'src/com/sixdee/crbtportal/ui/toolkit/uicomponent';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { UIComponentView } from 'src/com/sixdee/crbtportal/ui/toolkit/uicomponentview';
import { BlackListRowViewImpl } from './blacklistrowview';
import { UIComponentCSSStyle } from 'src/com/sixdee/crbtportal/ui/toolkit/uicomponentcss';
import { BlackListRowCSSStyleImpl } from './blacklistrowcss';
import { MemberDetailsDto } from 'src/com/sixdee/crbtportal/core/dto/listtones/memberdetailsdto';

export interface BlackListRowComponentProps extends UIComponentProps
{
    blacklistDto:MemberDetailsDto;
    position:number;
    onDeleteClick(memberdetailsdto:MemberDetailsDto):void;
}

export interface BlackListRowComponentHandler extends UIComponentHandler
{
    onDeleteClick():void;
}

export class  BlackListRowComponent extends UIComponentImpl<BlackListRowComponentProps, UIComponentState, UIDataModel> 
implements BlackListRowComponentHandler
{
    constructor(props: BlackListRowComponentProps)
    {
        super(props);
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new BlackListRowViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {  
            return new BlackListRowCSSStyleImpl(applicationContext);           
    }  

   onDeleteClick():void
   {
        this.props.onDeleteClick(this.props.blacklistDto);
   }
   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/blacklist/blacklisting/viewmodel/blacklistrowcomponent.tsx